import { ApplicationUser, DevelopViewInfo, ViewType } from '@ktvs8/gocoo-engine-front-end';

import { MProgramConditionList } from './MProgram/m-program-condition-list';
import MProgramConditionListItem from './MProgram/m-program-condition-list-item.json';
import { MProgramEdit } from './MProgram/m-program-edit';
import MProgramEditItem from './MProgram/m-program-edit-item.json';

import { MSupplierConditionList } from './MSupplier/m-supplier-condition-list';
import MSupplierConditionListItem from './MSupplier/m-supplier-condition-list-item.json';
import { MSupplierEdit } from './MSupplier/m-supplier-edit';
import MSupplierEditItem from './MSupplier/m-supplier-edit-item.json';
import { OrderSheetConditionList } from './OrderSheet/order-sheet-condition-list';
import OrderSheetConditionListItem from './OrderSheet/order-sheet-condition-list-item.json';
import OrderSheetGroupEditItem from './OrderSheet/order-sheet-group-edit-item.json';

import { InvoiceConditionList } from './Invoice/invoice-date-condition-list';
import InvoiceConditionListItem from './Invoice/invoice-date-condition-list-item.json';
import { OrderSheetGroupEdit } from './OrderSheet/order-sheet-group-edit';
import { ProgramEdit } from './Program/program-edit';
import ProgramEditItem from './Program/program-edit-item.json';
import { ProgramWeekTimeTable } from './Program/program-week-time-table';
import ProgramWeekTimeTableItem from './Program/program-week-time-table-item.json';
import ApplicationUserEditItem from './config/application-user-edit-item.json';
import ApplicationUserListItem from './config/application-user-list-item.json';
import ApplicationUserRole from './config/user-role.json';

/**
 * gocoo-engineにおけるview構成を保持したリスト
 */
export const GocooEngineDevelopViewInfoList: DevelopViewInfo[] = [
  {
    viewType: ViewType.ConditionList,
    dataType: 'MProgram',
    item: MProgramConditionListItem,
    script: new MProgramConditionList(),
  },
  {
    viewType: ViewType.Edit,
    dataType: 'MProgram',
    item: MProgramEditItem,
    script: new MProgramEdit(),
  },
  {
    viewType: ViewType.WeekTimeTable,
    dataType: 'Program',
    item: ProgramWeekTimeTableItem,
    script: new ProgramWeekTimeTable(),
  },
  {
    viewType: ViewType.Edit,
    dataType: 'Program',
    item: ProgramEditItem,
    script: new ProgramEdit(),
  },
  {
    viewType: ViewType.ConditionList,
    dataType: 'OrderSheet',
    item: OrderSheetConditionListItem,
    script: new OrderSheetConditionList(),
  },
  {
    viewType: ViewType.GroupEdit,
    dataType: 'OrderSheet',
    item: OrderSheetGroupEditItem,
    script: new OrderSheetGroupEdit(),
  },
  {
    viewType: ViewType.ConditionList,
    dataType: 'MSupplier',
    item: MSupplierConditionListItem,
    script: new MSupplierConditionList(),
  },
  {
    viewType: ViewType.Edit,
    dataType: 'MSupplier',
    item: MSupplierEditItem,
    script: new MSupplierEdit(),
  },
  {
    viewType: ViewType.ConditionList,
    dataType: 'Invoice',
    item: InvoiceConditionListItem,
    script: new InvoiceConditionList(),
  },
];

/**
 * アプリケーションユーザー関する情報を取得
 *
 * @remarks
 *  - アプリケーションユーザー一覧の画面の構成
 *  - アプリケーションユーザーの権限リスト
 * @returns
 */
export function GetGocooEngineApplicationUserInfo(): ApplicationUser {
  return new ApplicationUser(
    ApplicationUserListItem,
    ApplicationUserEditItem,
    ApplicationUserRole.Roles,
    'Production',
    'ProductionManager'
  );
}
